import React from 'react';
import {Link, Redirect} from 'react-router-dom'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import NavigateNext from '@material-ui/icons/NavigateNext';
import ApiFetcher from "../../ApiFetcher";
import Utility from "../../Utility";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    paper: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: 'auto',
        width: '80%',
    },
    iconButton: {
        textAlign: 'right',
    },
    circularProgress: {
        textAlign: 'center',
        margin: theme.spacing.unit,
    }
});

function createBackButton(path, label){
    const ButtonLink = props => <Link to={path} {...props} />;
    return (
        <Button component={ButtonLink} variant="contained" color="primary" fullWidth>{label}</Button>
    )
}

function createIconButton(pathname, search){
    const ButtonLink = props => <Link to={{pathname: pathname, search: search}} {...props} />;
    return (
        <IconButton color="primary" component={ButtonLink}>
            <NavigateNext fontSize="large"/>
        </IconButton>
    )
}

export class SelectPompSpec extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            pompSpecs: []
        };
        this.handleResponse = this.handleResponse.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('ポンプ仕様選択画面');
        }
    }

    componentDidMount(){
        ApiFetcher.getSelectItemPompSpec(this.props.cookies.get('token'), this.handleResponse);
    }

    handleResponse(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.pompSpecs)){
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            alert('ポンプ仕様の取得に失敗したためトップ画面に戻ります。');
            this.props.history.push(this.props.backPath);
        }
        else{
            this.setState({pompSpecs: responseJson.result.pompSpecs});
        }
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        if(this.state.pompSpecs.length === 0){
            // 応答待ち表示.
            return (
                <div className={this.props.classes.circularProgress}>
                    <CircularProgress/>
                </div>
            );
        }
        else{
            return (
                <div className={this.props.classes.root}>
                    <Paper className={this.props.classes.paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ポンプ仕様</TableCell>
                                    <TableCell/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.pompSpecs.map((row, i) =>{
                                    const search = '?pompSpecId=' + row.objectId;
                                    return (
                                        <TableRow key={i}>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell className={this.props.classes.iconButton}>{createIconButton(this.props.nextPath, search)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                    <div className={this.props.classes.button}>
                        {createBackButton(this.props.backPath, "トップ画面へ戻る")}
                    </div>
                </div>
            );
        }
    }
}

export default withStyles(styles)(SelectPompSpec);
